import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2m5f9qxwm: FaireProductEntity = {
  token: "p_n2m5f9qxwm",
  type: "product",
  name: "This Is Our Place Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/bd0e6a0f32689a9ce111885eb581231d274880ca3dbdddc80da5b88bb4888dbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/564c1f34dbcf915c7d64cc2b8dabf79c9925c7c6dcd157bad5234dd282a2850d.jpeg",
    "https://cdn.faire.com/fastly/65edaada1f061e67d4c5ee24867ed37ad8b2d1b3a4bf162b275e1403f9394248.jpeg",
    "https://cdn.faire.com/fastly/51395c0a473461e745786487c9e3f4e7169c46f945b5c7d4edf80e04dc9a04b5.jpeg"
  ],
  priceDollars: 8.5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of a cozy fruit bowl with an inspirational sentiment that reads \"This Is Our Place\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our This Is Our Place metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:37.734Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
